import axios from 'axios';

import { getStoredTokenData } from '../store/auth-context';
import { API_CONSTANTS } from './apiConstants';


const API_URL = API_CONSTANTS.API_URL;

export const authActions = async (authData) => {
	if (authData.mode === 'login') {
		return loginAction(authData.email, authData.password);
	}
	if (authData.mode === 'forgotPass') {
		return forgotPassAction(authData.email);
	}
};

const loginAction = async (email, password) => {
	return axios.post(`${API_URL}/api/login`, {
		email,
		password
	});
};

const forgotPassAction = async (email) => {
	return axios.put(`${API_URL}/api/forgot`, {
		email
	});
};

export const getUserInfo = async () => {
	const token = getStoredTokenData().token;
	return axios.get(`${API_URL}/api/get-single-user/`, {
		headers: {
			token: `${token}`
		}
	});
};

export const resetPassword = async (
	email,
	password,
	newPassword
) => {
	return axios.post(`${API_URL}/api/change-password`, {
		email,
		password,
		newPassword
	});
};
